import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import {
  Box,
  Paper,
  Typography,
  TextField,
  Button,
  Alert,
  CircularProgress
} from '@mui/material';
import { getApiUrl } from '../config';

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(''); // 'success' or 'error'
  const navigate = useNavigate();

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setMessage('');
    setStatus('');

    // Validate passwords match
    if (newPassword !== confirmPassword) {
      setStatus('error');
      setMessage('Passwords do not match');
      setLoading(false);
      return;
    }

    // Validate password strength
    if (newPassword.length < 8) {
      setStatus('error');
      setMessage('Password must be at least 8 characters long');
      setLoading(false);
      return;
    }

    try {
      const token = searchParams.get('token');
      if (!token) {
        setStatus('error');
        setMessage('Reset token is missing');
        return;
      }

      const response = await axios.post(`${getApiUrl()}/auth/reset-password`, {
        token,
        new_password: newPassword
      });

      setStatus('success');
      setMessage(response.data.message);
      
      // Redirect to login after 3 seconds on success
      setTimeout(() => navigate('/login'), 3000);
    } catch (error) {
      setStatus('error');
      setMessage(error.response?.data?.error || 'An error occurred while resetting your password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        background: 'linear-gradient(120deg, #2575fc 0%, #6a11cb 100%)',
        padding: '20px',
      }}
    >
      <Paper
        elevation={3}
        sx={{
          padding: 4,
          width: '100%',
          maxWidth: 400,
          borderRadius: '12px',
          boxShadow: '0 20px 40px rgba(0,0,0,0.1)',
        }}
      >
        <Typography variant="h5" component="h1" gutterBottom align="center" sx={{ mb: 3 }}>
          Create New Password
        </Typography>

        {message && (
          <Alert severity={status} sx={{ mb: 3 }}>
            {message}
          </Alert>
        )}

        <form onSubmit={handleSubmit}>
          <TextField
            label="New Password"
            type="password"
            fullWidth
            required
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            sx={{ mb: 2 }}
          />

          <TextField
            label="Confirm Password"
            type="password"
            fullWidth
            required
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            sx={{ mb: 3 }}
          />

          <Button
            type="submit"
            variant="contained"
            fullWidth
            disabled={loading}
            sx={{
              py: 1.5,
              mb: 2,
              backgroundColor: '#2575fc',
              '&:hover': {
                backgroundColor: '#1c5cc9',
              },
            }}
          >
            {loading ? <CircularProgress size={24} color="inherit" /> : 'Reset Password'}
          </Button>

          <Button
            onClick={() => navigate('/login')}
            fullWidth
            sx={{ textTransform: 'none' }}
          >
            Back to Login
          </Button>
        </form>
      </Paper>
    </Box>
  );
};

export default ResetPassword; 